<div class="container-fluid" style="height: 100%;">
  <div
    class="row pr-0"
    [@fadeInAnimation]="hasData ? 'show' : 'hide'"
    style="height: 100%;"
  >
    <app-side-layout
      class="col-xl-2 col-lg-3 col-md-3 d-none d-md-block offset-xl-1 offset-lg-0 offset-md-0 pr-xl-0 pr-2 pl-xl-0 pl-2"
    ></app-side-layout>
    <app-widgets-layout
      [blockToShow]="blockToShow"
      class="col-xl-8 col-lg-9 col-md-9 col-sm-12 d-block pl-2 pr-xl-0 pr-2"
    ></app-widgets-layout>
  </div>

  <div
    [@fadeInAnimation]
    *ngIf="!hasData"
    class="d-flex align-items-center justify-content-center container-fade"
  >
    <img
      [src]="splashImg"
      style="width: 400px; height: 400px;"
    />
  </div>
</div>
